// extracted by mini-css-extract-plugin
export default {"describePrakerja":"style_describePrakerja__Rs900","wrapperText":"style_wrapperText__gd38D","text":"style_text__JU5Xr","linkTo":"style_linkTo__L7mxh"};